export const isValid = (val, required=true, type=null) => {
  if (val && (val instanceof Date || val instanceof Object))
    return true

  if (!val || val == undefined)
    val = ""
  else
    val = val.trim()
  if (required && val.length == 0)
    return false
  if (val.length > 0)
    if (type == 'email') {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(String(val).toLowerCase()))
        return false
    }
  
  return true
}

export const capitalize = (str) => {
  return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
}

export const secondsToTime = (e) => {
  var h = Math.floor(e / 3600).toString().padStart(2,'0'),
  m = Math.floor(e % 3600 / 60).toString().padStart(2,'0');

  return h + ':' + m;
}

export const range = (start, count) => {   
  var foo = []
  for (var i = 0; i < count; i++) {
    foo.push({name:start + i,value:start + i})
  }
  return foo
}

export const getTommorow = () => {
  const date = new Date();
  const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  let nowDayName = days[date.getDay()];
  let tomorrow

  if(nowDayName !== 'Friday' || nowDayName !== 'Saturday'){
    tomorrow = 'tomorrow'
  }else{
    tomorrow = 'Monday'
  }

  return tomorrow
}